<template>
  <WdsStack
    justify-space-between
    align-center
    class="tw-bg-true-gray-50 tw-border-b tw-border-gray-200 tw-px-4 tw-py-3"
  >
    <slot name="title" />
    <slot name="actions" />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
</script>
